import { Component, OnInit, ViewChild } from '@angular/core';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IOrganisationTaskTypeFilter } from '../../interfaces/organisation-task-type-filter';
import { IPageResult } from '../../interfaces/page-result';
import { OrganisationTaskTypesService } from '../../services';

import { TaskTypeService } from '../../services';
import { Table, LazyLoadEvent, SelectItem } from 'primeng';
import { MessageService } from 'primeng';
import { IOrganisationTaskTypes } from '../../interfaces/organisation-task-types';

@Component({
  selector: 'organisation-task-types',
  styleUrls: ['./organisation-task-types.component.scss'],
  templateUrl: './organisation-task-types.component.html',
})
export class OrganisationTaskTypesComponent implements OnInit {
  isLoading: boolean;
  page: IPageResult<any> = {
    items: [],
    total: 0,
  };

  filter: IOrganisationTaskTypeFilter;
  private _filterSubject: Subject<IOrganisationTaskTypeFilter>;

  taskTypesColumns: any[] = [];

  private _affectedItems: any[] = [];
  invalidTaskTypes: IOrganisationTaskTypes[];

  @ViewChild('dt') dt: Table;

  private _orgTypes: { [key: number]: string };
  organisationTypeOpts: SelectItem[];

  constructor(
    private organisationTaskTypesService: OrganisationTaskTypesService,
    private taskTypeService: TaskTypeService,
    private messageService: MessageService,
  ) {
    this._filterSubject = new Subject<IOrganisationTaskTypeFilter>();
    this._filterSubject.pipe(debounceTime(500)).subscribe((f) => {
      this._load(f);
      this.filter = f;
    });

    this._orgTypes = {
      2: 'Customer',
      3: 'Supplier',
    };

    this.organisationTypeOpts = Object.keys(this._orgTypes).map((x) => ({
      label: this._orgTypes[x],
      value: x,
    }));
  }

  ngOnInit(): void {
    this.taskTypeService.get().then((res) => {
      if (res) {
        this._initTaskTypeColumns(res);
      }
    });
    this._applyFilter();
  }

  getOrgTypeName(key: number) {
    return this._orgTypes[key] || key;
  }

  search() {
    this._applyFilter();
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filter.first = event.first;
    this.filter.rows = event.rows;
    this.filter.sortField = event.sortField;
    this.filter.sortOrder = event.sortOrder;
    this._applyFilter();
  }

  clearFilter() {
    this.dt.sortField = '';
    this.dt.rows = 10;
    this.filter = null;
    this._applyFilter();
  }

  onTaskTypeCheckboxChange(event: boolean, data: any, field: number) {
    data[field] = event;
    let index = data.taskTypes.indexOf(field);
    if (event) {
      if (index === -1) {
        data.taskTypes.push(field);
      }
    } else {
      if (index !== -1) {
        data.taskTypes.splice(index, 1);
      }
    }

    index = this._affectedItems.findIndex((x) => x.id == data.id);
    if (index === -1) {
      this._affectedItems.push(data);
    }
  }

  get saveEnabled() {
    return this._affectedItems.length;
  }

  async save() {
    const itemsToSave = this._affectedItems.map((x) => ({
      id: x.id,
      name: x.name,
      taskTypes: x.taskTypes,
    }));

    // validate task types before saving
    this.invalidTaskTypes = await this.organisationTaskTypesService.validateTaskTypes(itemsToSave);
    if (this.invalidTaskTypes && this.invalidTaskTypes.length > 0) {
      //this.messageService.add(Message.Error("One or more task types do not have a corresponding service agreement and will not be saved.", "Error"));

      // change task types to string representation
      this.invalidTaskTypes.forEach((info) => {
        info.taskTypes = info.taskTypes.map((tt: number) => {
          return this.taskTypesColumns[tt - 1].header;
        });
      });
    }

    this.isLoading = true;
    this.organisationTaskTypesService.saveItems(itemsToSave).then(() => {
      this._affectedItems = [];
      this._applyFilter();
    });
  }

  private _applyFilter() {
    if (!this.filter) {
      this._initDefaultFilter();
    }
    this._filterSubject.next(this.filter);
  }

  private _initDefaultFilter() {
    this.filter = {
      first: 0,
      rows: 10,
      sortField: 'Name',
      sortOrder: 1,
      filters: {
        name: { value: null, matchMode: 'contains' },
        organisationType: { value: null, matchMode: 'equals' },
      },
    };
  }

  private _load(filter: IOrganisationTaskTypeFilter) {
    this.isLoading = true;
    this.organisationTaskTypesService.getPage(filter).then((result) => {
      this._initPage(result);
      this.isLoading = false;
    });
  }

  private _initTaskTypeColumns(taskTypes: any[]) {
    this.taskTypesColumns = taskTypes.map((x) => ({
      header: x.abbr || x.name,
      field: x.id,
    }));
    this._initPage(this.page);
  }

  private _initPage(page: IPageResult<any>) {
    this.page = {
      total: page ? page.total : 0,
      items: !page
        ? []
        : page.items.map(
            (x) =>
              this._affectedItems.find((a) => a.id == x.id) || {
                ...x,
                ...Object.assign(
                  {},
                  ...(this.taskTypesColumns || []).map((c) => ({
                    [c.field]: x.taskTypes.some((ts) => ts == c.field),
                  })),
                ),
              },
          ),
    };
    console.log('_initPage', this.page);
  }
}
